import { branchstore } from "../state/store";
import { WorkflowGroups } from "../state/types";
import { WorkflowColumn } from "./WorkflowColumn";

export type Props = WorkflowGroups;

function WorkflowGroupHeader({title, children, extraclass}) {
  return <div class={`workflow ${extraclass}`}>
    <div class="head"
      data-tooltip-id="job-tooltip" data-tooltip-content={title}>
      {title}
    </div>
    {children}
  </div>;
}

export function WorkflowGroup(props: Props) {
  const results = branchstore.results.value[props.fullname];
  return <WorkflowGroupHeader extraclass="" title={props.title}>
    {results && <div class="children"><WorkflowColumn results={results}></WorkflowColumn></div>}
    <div class="subgroups">{props.subgroups.map(WorkflowGroup)}</div>
  </WorkflowGroupHeader>;
}
